import { apiClient } from "./apiClient";
import type { DashboardStats } from "@/types/entities";

export const dashboardService = {
  stats: (params: { legalEntityId?: string; branchId?: string } = {}) =>
    apiClient.get<DashboardStats>("/dashboard/stats", { params }).then((r) => r.data),
};
